export default __webpack_public_path__ + "static/media/Published_Icon.eaac638a.svg";